const COOKIE_BANNERS = [
  'CookieConsent',
  'moove_gdpr_popup',
  'cookieyes-consent',
  'cmplz_marketing',
  'cmplz_preferences',
];
const DENIED = 'denied';
const GRANTED = 'granted';
const KEY_COOKIES_ACCEPTED = 'MIRAI:CORE:COOKIES_ACCEPTED';
const KEY_COOKIES_ACCEPTED_LEGACY = 'cookiesAccepted';
const POLICIES = {
  GOOGLE: { text: 'Google, Doubleclick, YouTube', url: 'https://business.safety.google/privacy/' },
  META: {
    text: 'Meta, Facebook, Instagram',
    url: 'https://es-es.facebook.com/privacy/policies/cookies/?entry_point=cookie_policy_redirect&entry=0',
  },
  MICROSOFT: {
    text: 'Microsoft',
    url: 'https://www.microsoft.com/es-mx/privacy/privacystatement#maincookiessimilartechnologiesmodule',
  },
  X: { text: 'Twitter, X', url: 'https://help.x.com/es/rules-and-policies/x-cookies' },
  YANDEX: { text: 'Yandex', url: 'https://yandex.com/legal/cookies_policy_eng/en/' },
};

export { COOKIE_BANNERS, DENIED, GRANTED, KEY_COOKIES_ACCEPTED, KEY_COOKIES_ACCEPTED_LEGACY, POLICIES };
